import { AccessToken } from './access-token';

export enum Role {
    ADMIN = 1,
    CUSTOMER = 2,
    VENDOR = 3,
    MANAGER = 4,
    STAFF = 5,
    TESTERS = 6,
}

export const USER_MODEL = 'user';

export interface User {
    id: number;
    role: Role;
    display_name: string;
    username?: string;
    first_name?: string;
    last_name?: string;
    avatar?: string;
    phone: string;
    email_verified_at: string;
    email: string;
    password: string;
    created_at: string;
    updated_at: string;
    tokens?: AccessToken[];
    has_password: boolean;
    model_type: typeof USER_MODEL;
    banned_at?: string;
    last_login_at?: string;
    bans?: {
        id: number;
        comment: string;
        expired_at?: string;
    }[];
    two_factor_confirmed_at?: string;
    two_factor_recovery_codes?: string[];
    timezone?: string;
    unread_notifications_count?: number;
}
